import * as React from "react";
import { cn } from "../../../lib/utils";
import { exprItemBase, fieldBtn, operatorBtn } from "./chipClasses";

const VARIANT_CLASS = {
  token: exprItemBase,
  operator: operatorBtn,
  field: fieldBtn,
};

/**
 * Presentational formula builder chip.
 * @param {"token"|"operator"|"field"} [variant="token"]
 * @param {boolean} [active] — optional highlight (caller may also pass className)
 * @param {React.ElementType} [as] — defaults to span for token, button for operator/field
 */
const FormulaChip = React.forwardRef(
  (
    {
      variant = "token",
      as,
      active = false,
      className,
      children,
      type,
      ...props
    },
    ref,
  ) => {
    const Comp = as || (variant === "token" ? "span" : "button");
    const isButton = Comp === "button";

    return (
      <Comp
        ref={ref}
        type={isButton ? type || "button" : type}
        className={cn(
          VARIANT_CLASS[variant] || exprItemBase,
          active && "ring-2 ring-primary/40 ring-offset-1",
          className,
        )}
        {...props}
      >
        {children}
      </Comp>
    );
  },
);
FormulaChip.displayName = "FormulaChip";

function FormulaOperatorButton({ className, active, children, ...props }) {
  return (
    <FormulaChip
      variant="operator"
      active={active}
      className={className}
      {...props}
    >
      {children}
    </FormulaChip>
  );
}

function FormulaFieldButton({ className, active, children, ...props }) {
  return (
    <FormulaChip variant="field" active={active} className={className} {...props}>
      {children}
    </FormulaChip>
  );
}

export {
  FormulaChip,
  FormulaOperatorButton,
  FormulaFieldButton,
  exprItemBase,
  operatorBtn,
  fieldBtn,
};
